import { DisplayTable } from '@policoders/ds';
import PageHeader from '@shared/components/page-header';

import { useUser } from '@modules/administration/pages/users/user.page.hook';

export const AdministrationUserPage = () => {
  const { lines, tActions, tColumns, tHeaderButtons, handleEdit } = useUser();

  return (
    <>
      <PageHeader title="Usuários" />
      <DisplayTable
        actions={tActions}
        columns={tColumns}
        headerButtons={tHeaderButtons}
        lines={lines}
        onLineClick={handleEdit}
      />
    </>
  );
};
